import { Component, OnInit } from '@angular/core'
import { UntypedFormControl } from '@angular/forms'
import { AddedToCartDialogComponent } from '@spartacus/cart/base/components'
import { Observable } from 'rxjs'
import { filter, map, shareReplay, startWith, switchMap, tap } from 'rxjs/operators'
import { EbOrderEntry } from '../../interface/eb-order-entry.interface'

@Component({
    selector: 'eb-added-to-cart-dialog',
    templateUrl: './eb-added-to-cart-dialog.component.html',
    styleUrls: ['./eb-added-to-cart-dialog.component.scss'],
    standalone: false
})
export class EbAddedToCartDialogComponent extends AddedToCartDialogComponent implements OnInit {
  minOrderQuantity: number

  getQuantityControl(): Observable<UntypedFormControl> {
    if (!this.quantityControl$) {
      this.quantityControl$ = this.entry$.pipe(
        filter(e => !!e),
        map((entry: EbOrderEntry) => {
          this.minOrderQuantity = entry.product.productSalesView?.minOrderQuantity
            ? entry.product.productSalesView.minOrderQuantity
            : 1
          return this.getQuantityFormControl(entry)
        }),
        switchMap(() =>
          this.form.valueChanges.pipe(
            // eslint-disable-next-line import/no-deprecated
            startWith(null),
            tap(valueChange => {
              if (valueChange) {
                this.activeCartFacade.updateEntry(
                  valueChange.entryNumber,
                  valueChange.quantity * this.minOrderQuantity
                )
                if (valueChange.quantity === 0) {
                  this.dismissModal('Removed')
                }
              } else {
                this.form.markAsPristine()
              }
            })
          )
        ),
        map(() => this.form.get('quantity') as UntypedFormControl),
        shareReplay({ bufferSize: 1, refCount: true })
      )
    }
    return this.quantityControl$
  }
}
